import { PLAN_BUILDER_INTERNET_URL } from "@/lib/clickthrough-destination";
import type { TopBannerProps } from "@/components/TopBanner/types";

export const TOP_BANNER_METADATA: TopBannerProps = {
  eyebrowText: "",
  mainText: "Get our best price today.",
  orderLinkUrl: PLAN_BUILDER_INTERNET_URL,
  orderLinkText: "Order online here",
  prePhoneCopy: ", or call ",
};

export const MOBILE_TOP_BANNER_METADATA: TopBannerProps = {
  eyebrowText: "",
  mainText: "",
  orderLinkUrl: PLAN_BUILDER_INTERNET_URL,
  orderLinkText: "Order online",
  prePhoneCopy: " or call ",
};

export const TOP_BANNER_VARIANTS = {
  default: TOP_BANNER_METADATA,
  mobile: MOBILE_TOP_BANNER_METADATA,
};
